const KEY = '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'


export interface ModerationCategories<T> {
    "harassment": T;
    "harassment/threatening": T;
    "sexual": T;
    "hate": T;
    "hate/threatening": T;
    "illicit": T;
    "illicit/violent": T;
    "self-harm/intent": T;
    "self-harm/instructions": T;
    "self-harm": T;
    "sexual/minors": T;
    "violence": T;
    "violence/graphic": T;
}

export interface ModerationResult {
    flagged: boolean;
    categories: ModerationCategories<boolean>;
    category_scores: ModerationCategories<number>;
}

export class ModerationResponse {
    id: string;
    model: string;
    results: ModerationResult[];

    constructor(data: any) {
        this.id = data.id;
        this.model = data.model;
        this.results = data.results;
    }
}


export interface SummaryOutput {
    output: Array<{
        type: string;
        content: Array<{ text: string }>
    }>
}

export const moderationService = {
    moderate: async (text: string) => {
        const res = await fetch("https://api.openai.com/v1/moderations", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${KEY}`,
            },
            body: JSON.stringify({
                model: "omni-moderation-latest",
                input: text,
                store: false,
            }),
        });

        const data = await res.json();
        return new ModerationResponse(data);
    },
    summarize: async (text: string) => {
        const response = await fetch("https://api.openai.com/v1/responses", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${KEY}`,
            },
            body: JSON.stringify({
                model: "gpt-5-mini",
                instructions: `
You are a chat-analysis module for a casual dating app to identify potential fraud or scam.  
Provide a short summary and assess whether the current user is a scammer or being scammed.  
Sexual or explicit content alone is acceptable and does not raise scam risk.

Output format (Markdown):
**Саммари:** 1–2 предложения, упоминай только то, что есть.

**Потенциальные проблемы:** 0–3 пункта, если есть.  

**Риск:** Низкий / Средний / Высокий — твоя оценка.

Rules (scam only):
- “Early externalization” — moving to outside messengers within the first 10 messages or 24 hours → increases risk. Later → neutral.  
- “Persistence” — 2+ repeated attempts to move off-platform after refusal or no reply → increases risk.  
- Unusual spelling of messenger names or unpopular ones (e.g., Zangi, Signal) → High.  
- Money, crypto, transfers, gifts, fees, or “verification payments” → always High.  
- Data extraction, blackmail, threats, or fake identities → High.  
- Early sexual talk without pressure → does not raise risk; persistent sexual pressure after refusal → Medium/High.  
- Consensual sexting and photo exchange without money or pressure → Low.
- Minor -> High.

Be concise and factual. Avoid speculation.  
Format in Markdown, bold section headers, and number the problems.  
Respond in Russian.
`,
                input: text,
                store: false,
            }),
        });

        const data = await response.json() as SummaryOutput;


        const summaryOutput = data.output.find(o => o.type === "message");
        const summary = summaryOutput?.content[0].text;

        console.log({output: data.output, summaryOutput, summary})

        return summary;
    }
}